import React from 'react';

import { Badge } from '../Badge';

import { SpreadProps } from './types';
import { Component } from './styles';

export const MobileSpread = React.memo(
  React.forwardRef<HTMLSpanElement, SpreadProps>(({ value }, ref) => {
    return (
      <Component>
        <Badge ref={ref} color="blue">
          {value}%
        </Badge>
      </Component>
    );
  })
);
